import { getRetailerOrBrandToken } from "@faire/help-center-utils/serialized-data/getRetailerOrBrandToken";
import listConversations from "@faire/web-api--source/endpoints/www/api/messenger/list-conversations/post";
import { IGetMessengerConversationsRequest } from "@faire/web-api--source/indigofair/data/IGetMessengerConversationsRequest";

import {
  InstantAnswerRequiredData,
  InstantAnswerRequiredDataFn,
} from "../types";
import { getSelectedBrandOrderFromLocalStorage } from "../utils/localStorage";

const SHOULD_NOT_DISPLAY_MESSAGE_CTA: InstantAnswerRequiredData = {
  field: "shouldDisplayCTAOfContactBrandOrRetailer",
  data: false,
};

const SHOULD_DISPLAY_MESSAGE_CTA: InstantAnswerRequiredData = {
  field: "shouldDisplayCTAOfContactBrandOrRetailer",
  data: true,
};

export const ShouldDisplayMessageCTADataFn: InstantAnswerRequiredDataFn =
  () => {
    const retailerOrBrandToken = getRetailerOrBrandToken();

    if (!retailerOrBrandToken) {
      return Promise.resolve(SHOULD_NOT_DISPLAY_MESSAGE_CTA);
    }

    // If no order is selected, we should not display the message CTA
    if (!getSelectedBrandOrderFromLocalStorage()) {
      return Promise.resolve(SHOULD_NOT_DISPLAY_MESSAGE_CTA);
    }

    return listConversations(
      IGetMessengerConversationsRequest.build({
        context_token: retailerOrBrandToken,
      })
    )
      .then<InstantAnswerRequiredData>((response) => {
        if (response.conversations.length === 0) {
          return SHOULD_NOT_DISPLAY_MESSAGE_CTA;
        }
        return SHOULD_DISPLAY_MESSAGE_CTA;
      })
      .catch(
        () => SHOULD_NOT_DISPLAY_MESSAGE_CTA
      ) as Promise<InstantAnswerRequiredData>;
  };
